import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import AirlineService from "../../../../services/catalogs/AirlineService";

export const REQUEST_DELETE_AIRLINE = "REQUEST_DELETE_AIRLINE";
export const DELETE_AIRLINE_SUCCESS = "DELETE_AIRLINE_SUCCESS";
export const DELETE_AIRLINE_ERROR = "DELETE_AIRLINE_ERROR";

function requestDeleteAirline() {
  return {
    type: REQUEST_DELETE_AIRLINE,
  };
}

function deleteAirlineSuccess(json) {
  return {
    type: DELETE_AIRLINE_SUCCESS,
    message: json.data,
  };
}

function deleteAirlineError(json) {
  return {
    type: DELETE_AIRLINE_ERROR,
    error: json.data,
  };
}

export function deleteAirline(airline_id) {
  return (dispatch) => {
    dispatch(requestDeleteAirline());
    return AirlineService.deleteAirline(airline_id).then((json) => {
      if (json.data.code === 200) {
        dispatch(deleteAirlineSuccess(json.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(deleteAirline(airline_id));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(deleteAirlineError(json.data));
      }
    });
  };
}
